import React from 'react';

import { Search } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { getClientPageIsLoaded } from 'redux/modules/page/selectors/get-client-page-is-loaded';
import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import { useSelector } from 'react-redux';
import { getFeatureFlags } from 'utils/feature-flags';
import { getSearchAndBrowseLoading } from 'redux/modules/search-and-browse/selectors';

import classNames from 'classnames';
import styles from '../index.scss';

type MobileSearchButtonProps = {
  toggleOverlay: () => void;
  withLabel: boolean;
};

const MobileSearchButton = ({ toggleOverlay, withLabel }: MobileSearchButtonProps) => {
  const { showSearchLoading } = getFeatureFlags();

  const clientPageIsLoaded = useSelector(getClientPageIsLoaded);
  const productsLoading = useSelector(getSearchAndBrowseLoading);

  const loading = showSearchLoading && (!clientPageIsLoaded || productsLoading);

  return (
    <Button
      aria-label="Search"
      data-testid="searchBtn"
      className={classNames(styles.searchBtn, {
        [styles.withLabel]: withLabel,
      })}
      onClick={toggleOverlay}
      theme="secondary"
      waiting={loading}
      width="fit"
    >
      <label
        className={classNames({
          [styles.searchButtonWithText]: withLabel,
        })}
        htmlFor="mobileSearchButton"
      >
        <Search />
        {withLabel && <span className={styles.searchButtonText}>Search</span>}
      </label>
    </Button>
  );
};

export default MobileSearchButton;
